import React from 'react';

const CommonFooter: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '20px 0',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div className="footer-logo">
            <img 
              src="/assets/images/jwil-logo.svg" 
              alt="JWIL Logo" 
              className="footer-logo-img"
              style={{ maxHeight: '50px' }}
            />
          </div>
          <div className="footer-socials">
            <h5 style={{ 
              marginBottom: '15px', 
              fontSize: '16px', 
              fontWeight: '600',
              textAlign: 'center'
            }}>
              Follow Us
            </h5>
            <div className="social-block" style={{ 
              display: 'flex', 
              gap: '15px',
              justifyContent: 'center'
            }}>
              <a 
                href="https://www.linkedin.com/company/jwil-infra-limited/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ transition: 'transform 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src="/assets/images/linkedin.svg" 
                  alt="LinkedIn" 
                  style={{ width: '32px', height: '32px' }} 
                />
              </a>
              <a 
                href="https://www.instagram.com/jwil.infra.ltd" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ transition: 'transform 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src="/assets/images/instagram.svg" 
                  alt="Instagram" 
                  style={{ width: '32px', height: '32px' }} 
                />
              </a>
              <a 
                href="https://x.com/JwilInfra" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ transition: 'transform 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src="/assets/images/x.svg" 
                  alt="X (Twitter)" 
                  style={{ width: '32px', height: '32px' }} 
                />
              </a>
              <a 
                href="https://www.facebook.com/JWIL.INFRA" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ transition: 'transform 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src="/assets/images/facebook.svg" 
                  alt="Facebook" 
                  style={{ width: '32px', height: '32px' }} 
                />
              </a>
              <a 
                href="https://www.youtube.com/@JWILInfra" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ transition: 'transform 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src="/assets/images/youtube.svg" 
                  alt="YouTube" 
                  style={{ width: '32px', height: '32px' }} 
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CommonFooter;
